import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _432d48d8 = () => interopDefault(import('../../../src/pages/sp/index.vue' /* webpackChunkName: "pages/sp/index" */))
const _25307794 = () => interopDefault(import('../../../src/pages/client/activate/index.vue' /* webpackChunkName: "pages/client/activate/index" */))
const _700b55ae = () => interopDefault(import('../../../src/pages/client/inactive/index.vue' /* webpackChunkName: "pages/client/inactive/index" */))
const _f71836ce = () => interopDefault(import('../../../src/pages/client/login.vue' /* webpackChunkName: "pages/client/login" */))
const _9335c73c = () => interopDefault(import('../../../src/pages/client/product/index.vue' /* webpackChunkName: "pages/client/product/index" */))
const _84fe055e = () => interopDefault(import('../../../src/pages/client/proposal_contracted/index.vue' /* webpackChunkName: "pages/client/proposal_contracted/index" */))
const _26adc240 = () => interopDefault(import('../../../src/pages/client/purchase_order_list/index.vue' /* webpackChunkName: "pages/client/purchase_order_list/index" */))
const _5d44de34 = () => interopDefault(import('../../../src/pages/company/inquiry/index.vue' /* webpackChunkName: "pages/company/inquiry/index" */))
const _83d6dfcc = () => interopDefault(import('../../../src/pages/company/invoice/index.vue' /* webpackChunkName: "pages/company/invoice/index" */))
const _37044f5c = () => interopDefault(import('../../../src/pages/company/product/index.vue' /* webpackChunkName: "pages/company/product/index" */))
const _36e5588a = () => interopDefault(import('../../../src/pages/company/proposal/index.vue' /* webpackChunkName: "pages/company/proposal/index" */))
const _0bfcaa4c = () => interopDefault(import('../../../src/pages/company/purchase_order_list/index.vue' /* webpackChunkName: "pages/company/purchase_order_list/index" */))
const _2aa00b7d = () => interopDefault(import('../../../src/pages/company/setting/index.vue' /* webpackChunkName: "pages/company/setting/index" */))
const _3858b01e = () => interopDefault(import('../../../src/pages/partner/login.vue' /* webpackChunkName: "pages/partner/login" */))
const _42904ec7 = () => interopDefault(import('../../../src/pages/terms/client.vue' /* webpackChunkName: "pages/terms/client" */))
const _74ad3d9f = () => interopDefault(import('../../../src/pages/terms/connect_service_agreement.vue' /* webpackChunkName: "pages/terms/connect_service_agreement" */))
const _706cfdc5 = () => interopDefault(import('../../../src/pages/terms/privacy_policy.vue' /* webpackChunkName: "pages/terms/privacy_policy" */))
const _27b74107 = () => interopDefault(import('../../../src/pages/client/activate/resend.vue' /* webpackChunkName: "pages/client/activate/resend" */))
const _632325db = () => interopDefault(import('../../../src/pages/client/password/reset.vue' /* webpackChunkName: "pages/client/password/reset" */))
const _b6b5192e = () => interopDefault(import('../../../src/pages/client/profile/connect_client/index.vue' /* webpackChunkName: "pages/client/profile/connect_client/index" */))
const _08dc8e1f = () => interopDefault(import('../../../src/pages/client/report/trouble/index.vue' /* webpackChunkName: "pages/client/report/trouble/index" */))
const _c312dcf0 = () => interopDefault(import('../../../src/pages/client/setting/accounts/index.vue' /* webpackChunkName: "pages/client/setting/accounts/index" */))
const _218db36c = () => interopDefault(import('../../../src/pages/client/setting/billing.vue' /* webpackChunkName: "pages/client/setting/billing" */))
const _04800724 = () => interopDefault(import('../../../src/pages/client/setting/company.vue' /* webpackChunkName: "pages/client/setting/company" */))
const _55bcd68c = () => interopDefault(import('../../../src/pages/client/setting/onboarding.vue' /* webpackChunkName: "pages/client/setting/onboarding" */))
const _26a4d39a = () => interopDefault(import('../../../src/pages/client/setting/profile.vue' /* webpackChunkName: "pages/client/setting/profile" */))
const _454e186f = () => interopDefault(import('../../../src/pages/company/profile/connect_company/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/index" */))
const _0ac1b25b = () => interopDefault(import('../../../src/pages/company/profile/reference_check/index.vue' /* webpackChunkName: "pages/company/profile/reference_check/index" */))
const _b924a8e8 = () => interopDefault(import('../../../src/pages/company/profile/team/index.vue' /* webpackChunkName: "pages/company/profile/team/index" */))
const _c24cf9ca = () => interopDefault(import('../../../src/pages/company/setting/account/index.vue' /* webpackChunkName: "pages/company/setting/account/index" */))
const _7dae916b = () => interopDefault(import('../../../src/pages/company/setting/company/index.vue' /* webpackChunkName: "pages/company/setting/company/index" */))
const _2caedc10 = () => interopDefault(import('../../../src/pages/company/setting/partner_inquiry_form.vue' /* webpackChunkName: "pages/company/setting/partner_inquiry_form" */))
const _9d1ac81a = () => interopDefault(import('../../../src/pages/company/setting/user/index.vue' /* webpackChunkName: "pages/company/setting/user/index" */))
const _19158390 = () => interopDefault(import('../../../src/pages/terms/list/client.vue' /* webpackChunkName: "pages/terms/list/client" */))
const _0f6ff8f0 = () => interopDefault(import('../../../src/pages/terms/list/company.vue' /* webpackChunkName: "pages/terms/list/company" */))
const _9676d49e = () => interopDefault(import('../../../src/pages/company/profile/connect_company/career.vue' /* webpackChunkName: "pages/company/profile/connect_company/career" */))
const _6d4a62b3 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/features/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/features/index" */))
const _34afcf64 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/info/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/info/index" */))
const _7ef1f40e = () => interopDefault(import('../../../src/pages/company/profile/connect_company/members/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/members/index" */))
const _28b63289 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/new_preview/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/new_preview/index" */))
const _9f206928 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/overview.vue' /* webpackChunkName: "pages/company/profile/connect_company/overview" */))
const _ed493fb0 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/policy/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/policy/index" */))
const _67d809b6 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/preview.vue' /* webpackChunkName: "pages/company/profile/connect_company/preview" */))
const _96b4212e = () => interopDefault(import('../../../src/pages/company/profile/connect_company/price/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/price/index" */))
const _d47de598 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/reference_check/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/reference_check/index" */))
const _7d85805a = () => interopDefault(import('../../../src/pages/company/profile/connect_company/representative/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/representative/index" */))
const _0b56512f = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/support/index" */))
const _34ebf31c = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_achievement.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_achievement" */))
const _08e316ca = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_achievements/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_achievements/index" */))
const _5d83e455 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_system/index.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_system/index" */))
const _265ef1a2 = () => interopDefault(import('../../../src/pages/company/profile/team/overview.vue' /* webpackChunkName: "pages/company/profile/team/overview" */))
const _b2ddc38e = () => interopDefault(import('../../../src/pages/company/profile/connect_company/features/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/features/edit" */))
const _3962d768 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/info/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/info/edit" */))
const _672ffa33 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/members/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/members/edit" */))
const _44601e24 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/policy/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/policy/edit" */))
const _f053ba7a = () => interopDefault(import('../../../src/pages/company/profile/connect_company/price/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/price/edit" */))
const _ef83c5ce = () => interopDefault(import('../../../src/pages/company/profile/connect_company/representative/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/representative/edit" */))
const _a85a5bee = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_achievements/detail.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_achievements/detail" */))
const _a8d3e97c = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_achievements/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_achievements/edit" */))
const _7892d590 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_achievements/review.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_achievements/review" */))
const _2a2fe057 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support_system/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/support_system/edit" */))
const _404f703d = () => interopDefault(import('../../../src/pages/company/profile/connect_company/support/edit.vue' /* webpackChunkName: "pages/company/profile/connect_company/support/edit" */))
const _52062965 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/members/detail/_id.vue' /* webpackChunkName: "pages/company/profile/connect_company/members/detail/_id" */))
const _7eaed13b = () => interopDefault(import('../../../src/pages/company/profile/connect_company/new_preview/members/_id.vue' /* webpackChunkName: "pages/company/profile/connect_company/new_preview/members/_id" */))
const _1e6ca150 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/new_preview/support_achievements/_id.vue' /* webpackChunkName: "pages/company/profile/connect_company/new_preview/support_achievements/_id" */))
const _2a8049f8 = () => interopDefault(import('../../../src/pages/company/profile/connect_company/member/_id.vue' /* webpackChunkName: "pages/company/profile/connect_company/member/_id" */))
const _40c7e88b = () => interopDefault(import('../../../src/pages/company/profile/member/support_achievements/_hash.vue' /* webpackChunkName: "pages/company/profile/member/support_achievements/_hash" */))
const _92fb62aa = () => interopDefault(import('../../../src/pages/company/proposal/detail/edit/_product_hash_id.vue' /* webpackChunkName: "pages/company/proposal/detail/edit/_product_hash_id" */))
const _6b8c712a = () => interopDefault(import('../../../src/pages/company/proposal/detail/index/_proposal_hash_id.vue' /* webpackChunkName: "pages/company/proposal/detail/index/_proposal_hash_id" */))
const _6ceb512a = () => interopDefault(import('../../../src/pages/company/proposal/detail/preview/_product_hash_id.vue' /* webpackChunkName: "pages/company/proposal/detail/preview/_product_hash_id" */))
const _61cc64a1 = () => interopDefault(import('../../../src/pages/operation/contract/regenerate/renewal/_renewal_hash_id/_hash.vue' /* webpackChunkName: "pages/operation/contract/regenerate/renewal/_renewal_hash_id/_hash" */))
const _394bd16a = () => interopDefault(import('../../../src/pages/client/password/auth/_hash.vue' /* webpackChunkName: "pages/client/password/auth/_hash" */))
const _2dcc6510 = () => interopDefault(import('../../../src/pages/client/profile/connect_company/_hash.vue' /* webpackChunkName: "pages/client/profile/connect_company/_hash" */))
const _b9959b44 = () => interopDefault(import('../../../src/pages/client/profile/member/_hash.vue' /* webpackChunkName: "pages/client/profile/member/_hash" */))
const _4bc3443e = () => interopDefault(import('../../../src/pages/client/profile/team/_hash.vue' /* webpackChunkName: "pages/client/profile/team/_hash" */))
const _465a45ba = () => interopDefault(import('../../../src/pages/client/setting/accounts/_hash.vue' /* webpackChunkName: "pages/client/setting/accounts/_hash" */))
const _468e309a = () => interopDefault(import('../../../src/pages/company/inquiry/player/_id.vue' /* webpackChunkName: "pages/company/inquiry/player/_id" */))
const _6e5f9224 = () => interopDefault(import('../../../src/pages/company/profile/member/_hash.vue' /* webpackChunkName: "pages/company/profile/member/_hash" */))
const _6c52c892 = () => interopDefault(import('../../../src/pages/operation/contract/regenerate/_hash.vue' /* webpackChunkName: "pages/operation/contract/regenerate/_hash" */))
const _a90ddcb0 = () => interopDefault(import('../../../src/pages/operation/hearing_sheet/finish/_hash.vue' /* webpackChunkName: "pages/operation/hearing_sheet/finish/_hash" */))
const _89d7ea38 = () => interopDefault(import('../../../src/pages/client/profile/connect_company/_connect_company_hash_id/member/_connect_company_member_hash_id.vue' /* webpackChunkName: "pages/client/profile/connect_company/_connect_company_hash_id/member/_connect_company_member_hash_id" */))
const _09f13062 = () => interopDefault(import('../../../src/pages/client/profile/connect_company/_connect_company_hash_id/support_achievement/_connect_company_support_achievement_hash_id.vue' /* webpackChunkName: "pages/client/profile/connect_company/_connect_company_hash_id/support_achievement/_connect_company_support_achievement_hash_id" */))
const _444975ba = () => interopDefault(import('../../../src/pages/client/activate/by_hash/_hash/_invited.vue' /* webpackChunkName: "pages/client/activate/by_hash/_hash/_invited" */))
const _02b5364d = () => interopDefault(import('../../../src/pages/client/product/_id/index.vue' /* webpackChunkName: "pages/client/product/_id/index" */))
const _54eb905c = () => interopDefault(import('../../../src/pages/company/client_survey/_connect_proposal_hash_id.vue' /* webpackChunkName: "pages/company/client_survey/_connect_proposal_hash_id" */))
const _011cdd9c = () => interopDefault(import('../../../src/pages/company/inquiry/_id.vue' /* webpackChunkName: "pages/company/inquiry/_id" */))
const _3d9a4203 = () => interopDefault(import('../../../src/pages/company/invoice/_invoice_hash_id.vue' /* webpackChunkName: "pages/company/invoice/_invoice_hash_id" */))
const _a912877a = () => interopDefault(import('../../../src/pages/company/product/_product_hash_id.vue' /* webpackChunkName: "pages/company/product/_product_hash_id" */))
const _da171774 = () => interopDefault(import('../../../src/pages/company/quotation/_product_hash_id.vue' /* webpackChunkName: "pages/company/quotation/_product_hash_id" */))
const _4fc01182 = () => interopDefault(import('../../../src/pages/hearing_sheet/pre/_hash.vue' /* webpackChunkName: "pages/hearing_sheet/pre/_hash" */))
const _2f925674 = () => interopDefault(import('../../../src/pages/operation/hearing_sheet/_hash.vue' /* webpackChunkName: "pages/operation/hearing_sheet/_hash" */))
const _5d9c2748 = () => interopDefault(import('../../../src/pages/terms/company/_id.vue' /* webpackChunkName: "pages/terms/company/_id" */))
const _be803a62 = () => interopDefault(import('../../../src/pages/terms/guideline/_id.vue' /* webpackChunkName: "pages/terms/guideline/_id" */))
const _836eb43c = () => interopDefault(import('../../../src/pages/client/product/_id/old.vue' /* webpackChunkName: "pages/client/product/_id/old" */))
const _246c670a = () => interopDefault(import('../../../src/pages/client/product/_id/proposal/index.vue' /* webpackChunkName: "pages/client/product/_id/proposal/index" */))
const _2dd362f8 = () => interopDefault(import('../../../src/pages/client/product/_id/proposal/_proposalId.vue' /* webpackChunkName: "pages/client/product/_id/proposal/_proposalId" */))
const _966d30b8 = () => interopDefault(import('../../../src/pages/client/contract/_proposal_hash_id/_renewal_hash_id.vue' /* webpackChunkName: "pages/client/contract/_proposal_hash_id/_renewal_hash_id" */))
const _5dca9b2f = () => interopDefault(import('../../../src/pages/client/quotation/_product_hash_id/_proposal_hash_id.vue' /* webpackChunkName: "pages/client/quotation/_product_hash_id/_proposal_hash_id" */))
const _7798a91e = () => interopDefault(import('../../../src/pages/company/contract/_proposal_hash_id/_renewal_hash_id.vue' /* webpackChunkName: "pages/company/contract/_proposal_hash_id/_renewal_hash_id" */))
const _25a9b4ba = () => interopDefault(import('../../../src/pages/company/product/_page/_id.vue' /* webpackChunkName: "pages/company/product/_page/_id" */))
const _2b197909 = () => interopDefault(import('../../../src/pages/company/renewal/_product_hash_id/_proposal_hash_id.vue' /* webpackChunkName: "pages/company/renewal/_product_hash_id/_proposal_hash_id" */))
const _642f753d = () => interopDefault(import('../../../src/pages/report/client_survey/_contract_hash_id/_year/_month.vue' /* webpackChunkName: "pages/report/client_survey/_contract_hash_id/_year/_month" */))
const _09afa66e = () => interopDefault(import('../../../src/pages/hearing_sheet/_hash.vue' /* webpackChunkName: "pages/hearing_sheet/_hash" */))
const _2d11da4a = () => interopDefault(import('../../../src/pages/inquiry_form/_id.vue' /* webpackChunkName: "pages/inquiry_form/_id" */))
const _162aab1e = () => interopDefault(import('../../../src/pages/login/_position.vue' /* webpackChunkName: "pages/login/_position" */))
const _37291892 = () => interopDefault(import('../../../src/pages/logout/_position.vue' /* webpackChunkName: "pages/logout/_position" */))
const _4487298e = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/sp",
    component: _432d48d8,
    name: "sp"
  }, {
    path: "/client/activate",
    component: _25307794,
    name: "client-activate"
  }, {
    path: "/client/inactive",
    component: _700b55ae,
    name: "client-inactive"
  }, {
    path: "/client/login",
    component: _f71836ce,
    name: "client-login"
  }, {
    path: "/client/product",
    component: _9335c73c,
    name: "client-product"
  }, {
    path: "/client/proposal_contracted",
    component: _84fe055e,
    name: "client-proposal_contracted"
  }, {
    path: "/client/purchase_order_list",
    component: _26adc240,
    name: "client-purchase_order_list"
  }, {
    path: "/company/inquiry",
    component: _5d44de34,
    name: "company-inquiry"
  }, {
    path: "/company/invoice",
    component: _83d6dfcc,
    name: "company-invoice"
  }, {
    path: "/company/product",
    component: _37044f5c,
    name: "company-product"
  }, {
    path: "/company/proposal",
    component: _36e5588a,
    name: "company-proposal"
  }, {
    path: "/company/purchase_order_list",
    component: _0bfcaa4c,
    name: "company-purchase_order_list"
  }, {
    path: "/company/setting",
    component: _2aa00b7d,
    name: "company-setting"
  }, {
    path: "/partner/login",
    component: _3858b01e,
    name: "partner-login"
  }, {
    path: "/terms/client",
    component: _42904ec7,
    name: "terms-client"
  }, {
    path: "/terms/connect_service_agreement",
    component: _74ad3d9f,
    name: "terms-connect_service_agreement"
  }, {
    path: "/terms/privacy_policy",
    component: _706cfdc5,
    name: "terms-privacy_policy"
  }, {
    path: "/client/activate/resend",
    component: _27b74107,
    name: "client-activate-resend"
  }, {
    path: "/client/password/reset",
    component: _632325db,
    name: "client-password-reset"
  }, {
    path: "/client/profile/connect_client",
    component: _b6b5192e,
    name: "client-profile-connect_client"
  }, {
    path: "/client/report/trouble",
    component: _08dc8e1f,
    name: "client-report-trouble"
  }, {
    path: "/client/setting/accounts",
    component: _c312dcf0,
    name: "client-setting-accounts"
  }, {
    path: "/client/setting/billing",
    component: _218db36c,
    name: "client-setting-billing"
  }, {
    path: "/client/setting/company",
    component: _04800724,
    name: "client-setting-company"
  }, {
    path: "/client/setting/onboarding",
    component: _55bcd68c,
    name: "client-setting-onboarding"
  }, {
    path: "/client/setting/profile",
    component: _26a4d39a,
    name: "client-setting-profile"
  }, {
    path: "/company/profile/connect_company",
    component: _454e186f,
    name: "company-profile-connect_company"
  }, {
    path: "/company/profile/reference_check",
    component: _0ac1b25b,
    name: "company-profile-reference_check"
  }, {
    path: "/company/profile/team",
    component: _b924a8e8,
    name: "company-profile-team"
  }, {
    path: "/company/setting/account",
    component: _c24cf9ca,
    name: "company-setting-account"
  }, {
    path: "/company/setting/company",
    component: _7dae916b,
    name: "company-setting-company"
  }, {
    path: "/company/setting/partner_inquiry_form",
    component: _2caedc10,
    name: "company-setting-partner_inquiry_form"
  }, {
    path: "/company/setting/user",
    component: _9d1ac81a,
    name: "company-setting-user"
  }, {
    path: "/terms/list/client",
    component: _19158390,
    name: "terms-list-client"
  }, {
    path: "/terms/list/company",
    component: _0f6ff8f0,
    name: "terms-list-company"
  }, {
    path: "/company/profile/connect_company/career",
    component: _9676d49e,
    name: "company-profile-connect_company-career"
  }, {
    path: "/company/profile/connect_company/features",
    component: _6d4a62b3,
    name: "company-profile-connect_company-features"
  }, {
    path: "/company/profile/connect_company/info",
    component: _34afcf64,
    name: "company-profile-connect_company-info"
  }, {
    path: "/company/profile/connect_company/members",
    component: _7ef1f40e,
    name: "company-profile-connect_company-members"
  }, {
    path: "/company/profile/connect_company/new_preview",
    component: _28b63289,
    name: "company-profile-connect_company-new_preview"
  }, {
    path: "/company/profile/connect_company/overview",
    component: _9f206928,
    name: "company-profile-connect_company-overview"
  }, {
    path: "/company/profile/connect_company/policy",
    component: _ed493fb0,
    name: "company-profile-connect_company-policy"
  }, {
    path: "/company/profile/connect_company/preview",
    component: _67d809b6,
    name: "company-profile-connect_company-preview"
  }, {
    path: "/company/profile/connect_company/price",
    component: _96b4212e,
    name: "company-profile-connect_company-price"
  }, {
    path: "/company/profile/connect_company/reference_check",
    component: _d47de598,
    name: "company-profile-connect_company-reference_check"
  }, {
    path: "/company/profile/connect_company/representative",
    component: _7d85805a,
    name: "company-profile-connect_company-representative"
  }, {
    path: "/company/profile/connect_company/support",
    component: _0b56512f,
    name: "company-profile-connect_company-support"
  }, {
    path: "/company/profile/connect_company/support_achievement",
    component: _34ebf31c,
    name: "company-profile-connect_company-support_achievement"
  }, {
    path: "/company/profile/connect_company/support_achievements",
    component: _08e316ca,
    name: "company-profile-connect_company-support_achievements"
  }, {
    path: "/company/profile/connect_company/support_system",
    component: _5d83e455,
    name: "company-profile-connect_company-support_system"
  }, {
    path: "/company/profile/team/overview",
    component: _265ef1a2,
    name: "company-profile-team-overview"
  }, {
    path: "/company/profile/connect_company/features/edit",
    component: _b2ddc38e,
    name: "company-profile-connect_company-features-edit"
  }, {
    path: "/company/profile/connect_company/info/edit",
    component: _3962d768,
    name: "company-profile-connect_company-info-edit"
  }, {
    path: "/company/profile/connect_company/members/edit",
    component: _672ffa33,
    name: "company-profile-connect_company-members-edit"
  }, {
    path: "/company/profile/connect_company/policy/edit",
    component: _44601e24,
    name: "company-profile-connect_company-policy-edit"
  }, {
    path: "/company/profile/connect_company/price/edit",
    component: _f053ba7a,
    name: "company-profile-connect_company-price-edit"
  }, {
    path: "/company/profile/connect_company/representative/edit",
    component: _ef83c5ce,
    name: "company-profile-connect_company-representative-edit"
  }, {
    path: "/company/profile/connect_company/support_achievements/detail",
    component: _a85a5bee,
    name: "company-profile-connect_company-support_achievements-detail"
  }, {
    path: "/company/profile/connect_company/support_achievements/edit",
    component: _a8d3e97c,
    name: "company-profile-connect_company-support_achievements-edit"
  }, {
    path: "/company/profile/connect_company/support_achievements/review",
    component: _7892d590,
    name: "company-profile-connect_company-support_achievements-review"
  }, {
    path: "/company/profile/connect_company/support_system/edit",
    component: _2a2fe057,
    name: "company-profile-connect_company-support_system-edit"
  }, {
    path: "/company/profile/connect_company/support/edit",
    component: _404f703d,
    name: "company-profile-connect_company-support-edit"
  }, {
    path: "/company/profile/connect_company/members/detail/:id?",
    component: _52062965,
    name: "company-profile-connect_company-members-detail-id"
  }, {
    path: "/company/profile/connect_company/new_preview/members/:id?",
    component: _7eaed13b,
    name: "company-profile-connect_company-new_preview-members-id"
  }, {
    path: "/company/profile/connect_company/new_preview/support_achievements/:id?",
    component: _1e6ca150,
    name: "company-profile-connect_company-new_preview-support_achievements-id"
  }, {
    path: "/company/profile/connect_company/member/:id?",
    component: _2a8049f8,
    name: "company-profile-connect_company-member-id"
  }, {
    path: "/company/profile/member/support_achievements/:hash?",
    component: _40c7e88b,
    name: "company-profile-member-support_achievements-hash"
  }, {
    path: "/company/proposal/detail/edit/:product_hash_id?",
    component: _92fb62aa,
    name: "company-proposal-detail-edit-product_hash_id"
  }, {
    path: "/company/proposal/detail/index/:proposal_hash_id?",
    component: _6b8c712a,
    name: "company-proposal-detail-index-proposal_hash_id"
  }, {
    path: "/company/proposal/detail/preview/:product_hash_id?",
    component: _6ceb512a,
    name: "company-proposal-detail-preview-product_hash_id"
  }, {
    path: "/operation/contract/regenerate/renewal/:renewal_hash_id?/:hash?",
    component: _61cc64a1,
    name: "operation-contract-regenerate-renewal-renewal_hash_id-hash"
  }, {
    path: "/client/password/auth/:hash?",
    component: _394bd16a,
    name: "client-password-auth-hash"
  }, {
    path: "/client/profile/connect_company/:hash?",
    component: _2dcc6510,
    name: "client-profile-connect_company-hash"
  }, {
    path: "/client/profile/member/:hash?",
    component: _b9959b44,
    name: "client-profile-member-hash"
  }, {
    path: "/client/profile/team/:hash?",
    component: _4bc3443e,
    name: "client-profile-team-hash"
  }, {
    path: "/client/setting/accounts/:hash",
    component: _465a45ba,
    name: "client-setting-accounts-hash"
  }, {
    path: "/company/inquiry/player/:id?",
    component: _468e309a,
    name: "company-inquiry-player-id"
  }, {
    path: "/company/profile/member/:hash?",
    component: _6e5f9224,
    name: "company-profile-member-hash"
  }, {
    path: "/operation/contract/regenerate/:hash?",
    component: _6c52c892,
    name: "operation-contract-regenerate-hash"
  }, {
    path: "/operation/hearing_sheet/finish/:hash?",
    component: _a90ddcb0,
    name: "operation-hearing_sheet-finish-hash"
  }, {
    path: "/client/profile/connect_company/:connect_company_hash_id?/member/:connect_company_member_hash_id?",
    component: _89d7ea38,
    name: "client-profile-connect_company-connect_company_hash_id-member-connect_company_member_hash_id"
  }, {
    path: "/client/profile/connect_company/:connect_company_hash_id?/support_achievement/:connect_company_support_achievement_hash_id?",
    component: _09f13062,
    name: "client-profile-connect_company-connect_company_hash_id-support_achievement-connect_company_support_achievement_hash_id"
  }, {
    path: "/client/activate/by_hash/:hash?/:invited?",
    component: _444975ba,
    name: "client-activate-by_hash-hash-invited"
  }, {
    path: "/client/product/:id",
    component: _02b5364d,
    name: "client-product-id"
  }, {
    path: "/company/client_survey/:connect_proposal_hash_id?",
    component: _54eb905c,
    name: "company-client_survey-connect_proposal_hash_id"
  }, {
    path: "/company/inquiry/:id",
    component: _011cdd9c,
    name: "company-inquiry-id"
  }, {
    path: "/company/invoice/:invoice_hash_id",
    component: _3d9a4203,
    name: "company-invoice-invoice_hash_id"
  }, {
    path: "/company/product/:product_hash_id",
    component: _a912877a,
    name: "company-product-product_hash_id"
  }, {
    path: "/company/quotation/:product_hash_id?",
    component: _da171774,
    name: "company-quotation-product_hash_id"
  }, {
    path: "/hearing_sheet/pre/:hash?",
    component: _4fc01182,
    name: "hearing_sheet-pre-hash"
  }, {
    path: "/operation/hearing_sheet/:hash?",
    component: _2f925674,
    name: "operation-hearing_sheet-hash"
  }, {
    path: "/terms/company/:id?",
    component: _5d9c2748,
    name: "terms-company-id"
  }, {
    path: "/terms/guideline/:id?",
    component: _be803a62,
    name: "terms-guideline-id"
  }, {
    path: "/client/product/:id/old",
    component: _836eb43c,
    name: "client-product-id-old"
  }, {
    path: "/client/product/:id/proposal",
    component: _246c670a,
    name: "client-product-id-proposal"
  }, {
    path: "/client/product/:id/proposal/:proposalId",
    component: _2dd362f8,
    name: "client-product-id-proposal-proposalId"
  }, {
    path: "/client/contract/:proposal_hash_id?/:renewal_hash_id?",
    component: _966d30b8,
    name: "client-contract-proposal_hash_id-renewal_hash_id"
  }, {
    path: "/client/quotation/:product_hash_id?/:proposal_hash_id?",
    component: _5dca9b2f,
    name: "client-quotation-product_hash_id-proposal_hash_id"
  }, {
    path: "/company/contract/:proposal_hash_id?/:renewal_hash_id?",
    component: _7798a91e,
    name: "company-contract-proposal_hash_id-renewal_hash_id"
  }, {
    path: "/company/product/:page/:id?",
    component: _25a9b4ba,
    name: "company-product-page-id"
  }, {
    path: "/company/renewal/:product_hash_id?/:proposal_hash_id?",
    component: _2b197909,
    name: "company-renewal-product_hash_id-proposal_hash_id"
  }, {
    path: "/report/client_survey/:contract_hash_id?/:year?/:month?",
    component: _642f753d,
    name: "report-client_survey-contract_hash_id-year-month"
  }, {
    path: "/hearing_sheet/:hash?",
    component: _09afa66e,
    name: "hearing_sheet-hash"
  }, {
    path: "/inquiry_form/:id?",
    component: _2d11da4a,
    name: "inquiry_form-id"
  }, {
    path: "/login/:position?",
    component: _162aab1e,
    name: "login-position"
  }, {
    path: "/logout/:position?",
    component: _37291892,
    name: "logout-position"
  }, {
    path: "/",
    component: _4487298e,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
